import { Link } from 'react-router-dom'

import { MarketingLead } from '@/components/marketing/marketing-lead'
import { MarketingSectionTitle } from '@/components/marketing/marketing-section-title'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export function MarketingCta({
  title,
  lead,
  primaryLabel,
  primaryHref,
  className,
}: {
  title: string
  lead: string
  primaryLabel: string
  primaryHref: string
  className?: string
}) {
  const isExternal = primaryHref.startsWith('http') || primaryHref.startsWith('mailto:')

  return (
    <section className={cn('marketing-cta', className)}>
      <div className="marketing-container marketing-cta__inner">
        <MarketingSectionTitle>{title}</MarketingSectionTitle>
        <MarketingLead className="marketing-lead--cta">{lead}</MarketingLead>
        {isExternal ? (
          <Button asChild variant="cta" size="cta">
            <a href={primaryHref} className="marketing-cta__button">
              {primaryLabel}
            </a>
          </Button>
        ) : (
          <Button asChild variant="cta" size="cta">
            <Link to={primaryHref} className="marketing-cta__button">
              {primaryLabel}
            </Link>
          </Button>
        )}
      </div>
    </section>
  )
}
